import React from "react";
import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import { CampaignBuilderDashboardApp } from "./components";

export default class extends Controller {
  private root: ReturnType<typeof createRoot> | null = null;

  connect() {
    this.root = createRoot(this.element as HTMLElement);
    this.root.render(<CampaignBuilderDashboardApp />);
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
  }
}
